import React from 'react';
import { createStyles, withStyles, ButtonGroup, Button } from '@material-ui/core';
import { compose } from 'recompose';
import 'react-redux';
import { RichUtils } from 'draft-js';
import classNames from 'classnames';
const styles = (theme) => createStyles({
    root: {
        marginBottom: theme.spacing(),
    },
    active: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
        },
    },
    buttonGroup: {
        marginRight: theme.spacing(),
        marginBottom: theme.spacing(),
    },
});
const RteToolbar = (props) => {
    const { classes, setEditorState, editorState } = props;
    function createBlockButtonProps({ blockType }) {
        return {
            className: classNames({
                [classes.active]: RichUtils.getCurrentBlockType(editorState) === blockType,
            }),
            onClick: () => setEditorState(RichUtils.toggleBlockType(editorState, blockType)),
        };
    }
    function createStyleButtonProps({ inlineStyle }) {
        const currentStyle = props.editorState.getCurrentInlineStyle();
        return {
            className: classNames({
                [classes.active]: currentStyle.has(inlineStyle),
            }),
            onClick: () => setEditorState(RichUtils.toggleInlineStyle(editorState, inlineStyle)),
        };
    }
    return (React.createElement("div", { className: classes.root },
        React.createElement(ButtonGroup, { className: classes.buttonGroup, size: "small" },
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'unstyled' })), "Normal"),
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-one' })), "H1"),
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-two' })), "H2"),
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-three' })), "H3"),
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-four' })), "H4"),
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-five' })), "H5"),
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-six' })), "H6"),
            React.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'blockquote' })), "Quote")),
        React.createElement(ButtonGroup, { size: "small" },
            React.createElement(Button, Object.assign({}, createStyleButtonProps({ inlineStyle: 'BOLD' })), "Bold"),
            React.createElement(Button, Object.assign({}, createStyleButtonProps({ inlineStyle: 'ITALIC' })), "Italic"),
            React.createElement(Button, Object.assign({}, createStyleButtonProps({ inlineStyle: 'UNDERLINE' })), "Underline"))));
};
export default compose(withStyles(styles))(RteToolbar);
